<template>
  <Label class="mb-2 block text-sm font-medium text-secondary" :for="id">
    {{ label }}
  </Label>

  <vue-tel-input
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    :placeholder="placeholder"
    :id="id"
    :name="name || id"
    :dropdownOptions="dropdownOptions"
    :inputOptions="inputOptions"
    mode="international"
    defaultCountry="BE"
    validCharactersOnly="true"
  >
  </vue-tel-input>
</template>

<script setup>
import { Label } from "radix-vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

const inputOptions = {
  showDialCode: true,
  type: "tel",
};

const dropdownOptions = {
  showSearchBox: true,
  showFlags: true,
  showDialCodeInList: true,
  showDialCodeInSelection: false,
};

defineEmits(["update:modelValue"]);

defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  id: { type: String, required: true },
  name: { type: String, required: false },
});
</script>

<style lang="scss">
.vue-tel-input {
  @apply [&:has(.open)]:outline-blue-600 [&:has(.open)]:border-transparent [&:has(.open)]:outline [&:has(.open)]:outline-2 rounded-sm border border-gray-200 focus-within:shadow-none focus-within:outline-blue-600 focus-within:border-transparent focus-within:outline focus-within:outline-2;

  .vue-tel-input:focus.vti__dropdown {
    @apply focus:outline-none appearance-none;
  }

  .vti__dropdown {
    @apply rounded-l-md;
  }

  .vti__dropdown-list {
    @apply top-[calc(100%+10px)] max-w-[calc(100vw-2rem)] sm:max-w-[calc(100vw-4rem)] shadow-lg rounded-sm border-secondary p-1.5;
  }

  .vti__dropdown-item {
    @apply rounded-xs flex gap-2.5 px-2 py-2.5 items-center text-tertiary;

    strong {
      @apply truncate font-medium text-primary dark:text-primary;
    }
  }

  .vti__selection {
    @apply relative after:content-[""] after:absolute after:w-5 after:h-5 after:right-0 after:bg-center after:bg-no-repeat after:bg-chevron-down;
  }

  .vti__dropdown-arrow {
    @apply opacity-0 w-5 h-5;
  }

  .vti__flag {
    @apply rounded-[2px];
  }

  .vti__input {
    @apply rounded-r-md placeholder-gray-400 focus:outline-none shadow-none appearance-none py-2.5;

    &:focus {
      box-shadow: none;
    }

    &.vti__search_box {
      @apply bg-[14px] bg-search-lg bg-no-repeat rounded-l-md w-full m-0 mb-2 pl-11 pr-3.5 focus:shadow-none focus:outline-transparent focus:border-blue-600 focus:border;
    }
  }
}
</style>
